import { render, staticRenderFns } from "./ProfileDropdownModal.vue?vue&type=template&id=12fc13db"
import script from "./ProfileDropdownModal.vue?vue&type=script&lang=js"
export * from "./ProfileDropdownModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports